<template>
  <div class="sj-container">
    <div class="sj-container-wrapper">

      <slot name="operate-wrapper">
        <div class="sj-operate-wrapper">
          <slot name="operateLeft" >
            <div class="operate-left">
          
            </div>
          </slot>
          <slot name="operateRight">
            <div class="operate-right">
            </div>
           </slot>
        </div>
      </slot>
     
      <div class="operate-line">
        <slot name="operateLine"></slot>
      </div>
      <div class="sj-content-wrapper">
        <slot name="contentCenter"></slot>
        <slot name="contentLeft"></slot>
        <slot name="contentRight">
          <div class="content-right">
            <div class="table-content">
              <slot name="contentBox"></slot>
            </div>
            <div class="table-footer">
              <slot name="amount"><div></div></slot>
              <slot name="pagnation"></slot>
            </div>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
export default {
  name: "KTSubheader",
  data(){
    return{
      pageTitle:""
    }
  },
  computed: {
    ...mapGetters([
      "layoutConfig",
      "breadcrumbs",
      // "pageTitle",
      "layoutConfig"
    ]),
    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },

    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");
      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }
      }
      return classes.join(" ");
    }
  },
  created(){
    //  console.log(this.$route.path);
    // console.log(this.$route["path"])
    // console.log(this.$route)
    this.pageTitle=this.$route.meta.title;
    var breadcrumb=[]
    if(this.$route.matched.length>0){
      this.$route.matched.forEach((el,i)=>{
        if(i>0){
          breadcrumb.push({ title:el.meta.title,route:el.path})
        }
      })
    }
    this.$store.dispatch(SET_BREADCRUMB, breadcrumb);
  }
};
</script>
<style  scoped>
  .pageTitle{
    width:80px;
    color:#fff;
    /* font-weight: 600; */
    font-size: 16px;
  }
  /* .sj-operate-wrapper{
    position: fixed;
    top: 90px;
    z-index: 95;
    width: 95%;
  } */
</style>